import shared from '../shared';

function hideLoading($button, extraClasses) {
	shared.allowSubmit = true;
	$button
		.addClass(extraClasses)
		.removeClass('loading')
		.removeAttr('aria-busy');
}

export default hideLoading;
